module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_moto.6e42872f.jpg";